/**
 * 配置说明
 * img: 示例的图片
 * title: 示例的标题
 * path: 示例的路径：examples文件夹下md的地址
 * 如 examples/radar/pointStyle.md 示例，path为 radar-pointStyle
 */
export default [
  {
    img: 'https://p2.ssl.qhimg.com/d/inn/e48ee7ed2877/multipleXAxis.png',
    title: '双X轴折线图',
    path: 'line-multipleXAxis'
  },
  {
    img: 'https://p0.ssl.qhimg.com/t0144009aa56754cd60.png',
    title: '双Y轴折线图',
    path: 'line-multipleYAxis'
  },
  {
    img: 'https://p5.ssl.qhimg.com/t013417fb93fa37e2ea.png',
    title: '坐标轴间隔显示',
    path: 'line-axisLine'
  },
  {
    img: 'https://p2.ssl.qhimg.com/t01d660089a40290d6a.png',
    title: '折线结束点',
    path: 'line-endPoint'
  },
  {
    img: 'https://p4.ssl.qhimg.com/t010c7b316126d20d3d.png',
    title: '折线面积图',
    path: 'area-lineArea'
  },
  {
    img: 'https://p5.ssl.qhimg.com/d/inn/e48ee7ed2877/mixLineAndBar.png',
    title: '图表组合',
    path: 'line-mixLineAndBar'
  },
  {
    img: 'https://p0.ssl.qhimg.com/t01abca5ece564da66a.png',
    title: '隐藏坐标轴',
    path: 'bar-noAxis'
  },
  {
    img: 'https://p1.ssl.qhimg.com/t01a84f61bbda1ef444.png',
    title: '柱状图颜色渐变',
    path: 'bar-gradualBar'
  },
  {
    img: 'https://p4.ssl.qhimg.com/t01ecf1d8114c5aa86b.png',
    title: '切角柱状图',
    path: 'bar-cutBar'
  },
  {
    img: 'https://p1.ssl.qhimg.com/t0153188b21ef99f471.png',
    title: '无坐标散点图',
    path: 'scatter-common'
  },
  {
    img: 'https://p4.ssl.qhimg.com/t0168ac425d625cd18f.png',
    title: '散点图',
    path: 'scatter-safe'
  },
  {
    img: 'https://p4.ssl.qhimg.com/t011fd6cb1216213c93.png',
    title: '散点折线图',
    path: 'scatter-line'
  },
  {
    img: 'https://p5.ssl.qhimg.com/t0157877d6e2d30f7b9.png',
    title: '简洁雷达图',
    path: 'radar-easy'
  },
  {
    img: 'http://p2.qhimg.com/t01670ed67013eafe8b.png',
    title: '间距堆叠条形图',
    path: 'bar-gapStackBar'
  },
  {
    img: 'https://p1.ssl.qhimg.com/d/inn/67523310f062/gapStackBar2.png',
    title: '间距堆叠条形图2',
    path: 'bar-gapStackBar2'
  },
  {
    img: 'http://p9.qhimg.com/t0173ea1c4135741bf9.png',
    title: '纹理条形图',
    path: 'bar-textureBar'
  },
  {
    img: 'https://p2.ssl.qhimg.com/t016f1be9b3f280bb41.png',
    title: '自定义颜色极坐标柱状图',
    path: 'polarBar-stackPolarBar'
  },
  {
    img: 'https://p5.ssl.qhimg.com/t0111906506d1b724d5.png',
    title: '负值堆叠柱状图',
    path: 'bar-negativeStackBar'
  },
  {
    img: 'https://p0.ssl.qhimg.com/d/inn/df0b4188f12f/negativeStackBar2.png',
    title: '负值堆叠柱状图2',
    path: 'bar-negativeStackBar2'
  },
  {
    img: 'https://p3.ssl.qhimg.com/t012408ef8db6084cbd.png',
    title: '动态文字环图',
    path: 'pie-donut'
  }
]
